import type { NavItem } from './types';

export const navItems: NavItem[] = [
  { label: '首页', href: '/' },
  { label: '折扣优惠', href: '/category/discount' },
  { label: '会员权益', href: '/category/membership' },
  { label: '生活补贴', href: '/category/subsidy' },
  { label: '职场福利', href: '/category/workplace' },
  { label: '关于我们', href: '/about' },
];